import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import Updates from 'features/updates';

const Page = () => (
  <MainLayout>
    <Updates />
  </MainLayout>
);

export default Page;
